import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import Swal from "sweetalert2";
import './registerServiceWorker'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/styme.css';

Vue.config.productionTip = false

Vue.prototype.API = './api/user.inc.php?mode=';
// Vue.prototype.API = 'http://127.0.0.1/porter-app/api/user.inc.php?mode=';
Vue.prototype.$swal = Swal;


if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
    .then(reg => console.log('Service Worker Registered!', reg))
    .catch(err => console.log('Service Worker registration failed:', err));
}


// const axios = require('axios');
// let data = JSON.stringify({
//   "username": "user",
//   "password": localStorage.getItem('device_id')
// });

// let config = {
// method: 'post',
// maxBodyLength: Infinity,
// url: '/api/login',
// headers: { 
//     'Content-Type': 'application/json'
// },
//   data : data
// };

//   axios.request(config)
// .then((response) => {
//   console.log(JSON.stringify(response.data));
// })
// .catch((error) => {
//   console.log(error);
// });

// 1. ตั้งค่า JWT ถ้ามีใน localStorage
const token = localStorage.getItem('jwt_token')
if (token) {
  console.log(token)
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}


axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      console.log('JWT----------------------ssss',error)
    }
    // return Promise.reject(error)
  }
)
// 2. ดัก JWT หมดอายุ → login ใหม่ (เฉพาะกรณี 401)
// axios.interceptors.response.use(
//   response => response,
//   async error => {
//     if (error.response && error.response.status === 401) {
//       const deviceId = localStorage.getItem('device_id')
//       if (deviceId) {
//         try {
//           const res = await axios.post('/api/login', { device_id: deviceId ,officer_id: localStorage.getItem('officer_id')})
//           const newToken = res.data.token
//           if (newToken) {
//             localStorage.setItem('jwt_token', newToken)
//             axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
//             // reload เพื่อให้ทุก request ใช้ token ใหม่
//             window.location.reload()
//           } else {
//             router.push('/login')
//           }
//         } catch (e) {
//           router.push('/login')
//         }
//       } else {
//         router.push('/login')
//       }
//     }
//     return Promise.reject(error)
//   }
// )

// 3. เช็คว่า user มี device_id หรือไม่ก่อนสร้าง Vue app
const deviceId = localStorage.getItem('device_id')
if (!deviceId) {
  router.push('/login')
} else {
  // สร้าง Vue app ได้เลย ถ้ามี device_id และ JWT อยู่
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}



